import { Request } from '../main'
import { Container, Image, Row, Col } from 'react-bootstrap'
import { useRouter } from 'next/router' 
import Link from 'next/link';
import Social from "./Social"
import Pixel from './Pixel'
import { isDomain } from '../utils/general'

const request = new Request(process.env.apiDomain)
const SocialLinks = url => (
    <Link href={url.link}><a className="footer__socialLinks p-1 border rounded-circle d-block text-center mr-3 mb-3 text-white">{url.children}</a></Link>
)
const Footer = (props) => {

    const router = useRouter()
    const path = router.pathname.split('/');
    const site = props.site
    const { data: profile } = request.account.swrAccountProfile(props.site.accountId);
    const { data: social } = request.account.swrSocialMedia(props.site.accountId, profile ? profile.user.id : profile);
    const { data: accountdata } = request.account.swrAccountData(props.site.accountId, "account_facebook_pixel");
    const {data: hub} = request.website.swrSite(props.site.accountId, "HUB")
    const hubSubdomainUrl = hub ? hub.subdomainUrl : '';

    const config = hub && hub.config ? JSON.parse(hub.config) : '';
    const is_forwarding = config && config.is_forwarding ? config.is_forwarding : 0;

    const hubUrl = hub ? (isDomain(hub.url) && is_forwarding == 0 ? 'www.'+hub.url : hubSubdomainUrl) : '';

    let accntdata = {};
    try {
        accntdata = JSON.parse(accountdata.data);
    } catch {
        accntdata = {};
    }

    function navGroup()
    {
        var nav = [];
        for (var i=0; i<props.navigation.length; i+=3) {
            nav.push(props.navigation.slice(i,i+3));
        }
        return nav;
    }
    
    return (
    <footer className="mt-auto">
        <div className="footer__menu py-5 text-white">
            <Container>
                <Row>
                    <Col md={3} className="order-md-1">
                        <div className="footer__user d-lg-flex align-items-center pt-lg-4 text-center">
                            <Image width={60} height={60} src={props.site.brand ? props.site.brand : "/images/profile-default.jpg"} className="mr-lg-3 mb-lg-0 mb-2" alt={props.site.name}   />
                            <p className="mb-0 h5 text-md-left">{props.site.name} <br /> <span className="fphone">{ profile && profile.phone ? profile.phone : null }</span> </p>
                        </div>
                    </Col>
                    <Col md={3} className="order-md-3">
                        <div className="d-flex align-items-start pt-3  pl-md-3 flex-wrap justify-content-md-start justify-content-center">
                            { social ? <Social customize={props.customize} social={social} /> : null }
                        </div>
                    </Col>
                    <Col md={6} className="order-md-2 footer__menuLinks">
                        <div className="d-flex justify-content-around ">
                            {navGroup().map( (group, key) =>  
                            <ul key={key} className="footer__list pl-0">
                                { group.map( (nav, key) => {
                                    if(props.customize)
                                        return <li key={key} className="my-3"><a className="footer__links text-white " >{nav.label}</a></li>
                                    let siteUrl = new URL("http://" + props.host)
                                    let navUrl = new URL("http:" + nav.href)
                                    if (navUrl.hostname == siteUrl.hostname)
                                        return (<li key={key} className="my-3">
                                            <Link href={props.customize ? '#' : navUrl.pathname} key={key}><a className="footer__links text-white " >{nav.label}</a></Link>
                                        </li>)
                                    else
                                        return (<li key={key} className="my-3">
                                            <a href={props.customize ? '#' : nav.href} key={key} className="footer__links text-white " >{nav.label}</a>
                                        </li>)
                                } ) }
                            </ul>
                            )}
                        </div>
                    </Col>
                </Row>

            </Container>
        </div>

        <div className="footer__copyright text-white">
            <Container>
                <Row>
                    <Col md={{span:6, order:2}} className="text-md-right text-center">
                        <p><Link href={hub ? 'https://'+hubUrl+'/privacy-policy' : '#'} key="1"><a>Privacy Policy</a></Link></p>
                    </Col>                    
                    <Col md={{span:6, order:1}} className="text-md-left text-center">
                        <p>Copyright &copy; {props.site.name} All Rights Reserved<br/>
                            I am not a medical professional. This site is for informational purposes only.</p>
                    </Col>
                </Row>
            </Container>
        </div>

        <Pixel name={"FACEBOOK_PIXEL_1"} props={accntdata} />
        <style jsx>{`
        
			.footer__menu{
				background-color: ${
					path[1] === 'discover' ? '#225d25' : 
					path[1] === '7big-secrets-to-180' ? '#484848' : 
					path[1] === '7ways-to-improve-memory' ? '#28444f' :
					path[1] === 'vitality-for-life-newsletter' ? '#332525' : 
					path[1] === 'what-your-doctor-wasnt-taught' ? '#0f0f0f' : 
					path[1] === 'vitamin-checklist' ? '#484848' : 
					(path[1] === 'explore' && props.origin === 'wellness') ? '#225d25' : 
					(path[1] === 'explore' && props.origin === 'business') || (path[1] === 'yfp101' && props.origin === 'business')  ? '#f7f7f7' : 
					path[1] === 'guide-to-start-an-online-business' ? '#308d9f' : 
					props.origin === 'wellness' ? '#225d25' : 
					props.origin ==='business' ? '#f7f7f7' : '#f2f2f2'};    
			}
            
            .footer__list{
                list-style:none;
                font-size:1rem;
            }

            .myStrip__media{
                padding-top:2px;
            }

            .footer__links{
                font-size:.85rem
            }

            .fphone{
                font-size:.85rem;
            }

        `}</style>

        <style jsx global>{`
        
            .footer__menuLinks{
                border-top:1px solid;
                border-color: ${
                    (path[1] === 'discover') ? '#ecca28' : 
                    path[1] === '7big-secrets-to-180' ? '#a06a50' : 
                    path[1] === '7ways-to-improve-memory' ? '#47d9bf' :
                    path[1] === 'vitality-for-life-newsletter' ? '#6b8138' : 
                    path[1] === 'what-your-doctor-wasnt-taught' ? '#00aec7' : 
                    path[1] === 'vitamin-checklist' ? '#FC895A' : '#9dcc9f'};
            }
            
            .footer__socialLinks{
                width: 35px;
                height: 35px;
                border-width: 2px!important;
            }
            
			.footer__copyright {
				background: #252525;
				font-size: 0.75rem;
				padding-top: 25px;
				padding-bottom: 5px;
			}
            
			.footer__copyright a {
				color: #359a88;
			}
            
            @media (min-width:768px){
                .footer__menuLinks{
                    border-right: 1px solid;
                    border-left: 1px solid;
                    border-top:0;
                    border-color: 
                        ${(path[1] === 'discover') ? '#ecca28' : 
                        path[1] === '7big-secrets-to-180' ? '#a06a50' : 
                        path[1] === '7ways-to-improve-memory' ? '#47d9bf' :
                        path[1] === 'vitality-for-life-newsletter' ? '#6b8138' : 
                        path[1] === 'what-your-doctor-wasnt-taught' ? '#00aec7' : 
                        path[1] === 'vitamin-checklist' ? '#FC895A' : '#9dcc9f'};
                }
            }
        `}</style>
    </footer> 
    );
};

export default Footer;